import { Controller } from '@hotwired/stimulus'
import { AutoMonetize } from '../utils'

// Connects to data-controller="link"
export default class extends Controller {
  static targets = ['partners', 'merchant']

  static values = { native: Boolean }

  connect() {
    AutoMonetize.loadPartnersFrom(this.partnersTarget)
    this.merchantTargets.forEach((element) => this.#prepare(element))
  }

  disconnect() {
    AutoMonetize.clear()
  }

  // Links arriving after connect(): the infinite pagination of /reservations, the
  // `options` bottom sheet loaded into its turbo_frame. On the first render this
  // callback runs BEFORE connect() — Context#connect starts the target observer
  // before calling the controller — so there is no partner table yet: connect()
  // takes care of that batch itself.
  merchantTargetConnected(element) {
    if (AutoMonetize.data) this.#prepare(element)
  }

  // Web only: the views render this action unless hotwire_native_app?. In the app the
  // href already IS the affiliate url (see #prepare), so there is no click to take.
  automonetize(event) {
    const { href, target, rel } = event.currentTarget
    const automonetize = new AutoMonetize(href, { target, rel })
    if (!automonetize.canMonetize()) return

    event.preventDefault()
    automonetize.goToGeneratedUrl()
  }

  #prepare(element) {
    if (!this.nativeValue || 'linkMonetized' in element.dataset) return

    // In the app the href is the outbound url: bridge--merchant-link hands it to
    // Safari on iOS, and on Android the target="_blank" window carries it as it
    // stands. An affiliated product keeps its href — the server 302 /redirection
    // matches no partner — so Amazon still goes out through Rails.
    const automonetize = new AutoMonetize(element.href)
    if (!automonetize.canMonetize()) return

    // Rewriting twice would nest one tracking url inside another: a cached Turbo
    // snapshot comes back with the href already rewritten, and the merchant domain
    // survives encodeURIComponent intact inside `ued=`, so it still matches its own
    // partner pattern. The mark travels with the snapshot clone; the flag would not.
    element.dataset.linkMonetized = ''
    element.href = automonetize.monetizedUrl
  }
}
